import './footer.css'
function Footer(){
  return(
    <footer>
      <div className='footer'>
        <h2>
          GOOD <span className='old-thing'><span className="O">O</span><span className="L">L</span><span className="D">D</span> </span>KATY
        </h2>

        <div className='subscribe-section'>
          
          <div className="email-input">
          <input id="suggestion-bar" className="join-bar" type="text" placeholder='Suggest here!' /> 
          <button onClick={() =>{
            let x = document.getElementById("suggestion-bar");
            if(x.value == "")
            {
              x.placeholder = "Please submit a resource"
            }
            else{
            document.getElementById("suggestion-bar").value = "";
            document.getElementById("suggestion-bar").placeholder = "Thank you!";
            document.getElementById("suggestion-bar").disabled = true;
            }
          }} className='join-button'>SEND</button>
          </div>
          <p>
            Missing a vital resource? Suggest one here to <br/>contribute to the community
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;